export enum EPaymentEntity {
  naicom = 'NAICOM',
  cifm = 'CIFM',
  arian = 'ARIAN',
}
